<template>
  <div style="position:relative">
    <div class="topbox">
      <div style="display:flex;">
        <div class="showNum">
          <p>被投递数</p>
          <p
            @click="handleGoDeliveryNumber"
            style="font-size:16px;color:rgba(0,119,255,1);cursor: pointer;"
          >
            {{ DeliveryNumber }} 人
          </p>
        </div>
        <div style="margin-left:15px;margin-right:15px;" class="showNum">
          <p>被收藏数</p>
          <p style="font-size:16px;color:rgba(36,158,119,1);">
            {{ CollectNumber }}人
          </p>
        </div>
      </div>
    </div>
    <div class="detailsBox">
      <!-- 标题 -->
      <div class="companyMsg">
        <p class="companyMsgTitle">公司信息</p>
      </div>
      <!-- 公司名称 -->
      <div class="companyName">
        <span>公司名称 :</span>
        <span>{{ companyName }}</span>
        <img style="width:133px;height:40px;" :src="companyLogo" alt />
      </div>
      <!-- 公司规模 -->
      <div class="companySize">
        <div v-show="isHR === false">
          <span>对外显示名称 :</span>
          <span>{{ ExternalName }}</span>
        </div>
        <div>
          <span>公司规模 :</span>
          <span>{{ companySize }}</span>
        </div>
        <div>
          <span>融资阶段 :</span>
          <span>{{ FinancingStage }}</span>
        </div>
      </div>
      <!-- 公司福利 -->
      <div class="companywelfare">
        <span>公司福利 :</span>
        <el-tag
          style="margin-right:5px;"
          size="mini"
          type="info"
          :key="index"
          v-for="(item, index) in dynamicTags"
          >{{ item.treatment_name }}</el-tag
        >
      </div>
      <!-- 公司简介 -->
      <div class="companyInfo">
        <p>公司简介 :</p>
        <p v-for="(item, index) in companyInfo" :key="index">{{ item }}</p>
      </div>

      <!-- 职位 -->
      <div class="positionMsg">
        <p class="positionTitle">职位信息</p>
      </div>
      <!-- 职位名称 -->
      <div class="positionName">
        <span>职位名称 :</span>
        <span>{{ positionName }}</span>
      </div>
      <!-- 职能分类 -->
      <div class="classification">
        <div>
          <span>职能分类 :</span>
          <span>{{ FunctionalClassification }}</span>
        </div>
        <div>
          <span>工作地点 :</span>
          <span>{{ workplace }}</span>
        </div>
        <div>
          <span>薪资范围 :</span>
          <span>{{ SalaryRange }}</span>
        </div>
      </div>

      <!-- 要求 -->
      <div class="positionRequirement">
        <p class="positionRequirementTitle">职位要求</p>
      </div>
      <!-- 工作年限 -->
      <div class="workyears">
        <div>
          <span>工作年限 :</span>
          <span>{{ workyears }}</span>
        </div>
        <div>
          <span>学历要求 :</span>
          <span>{{ AcademicRequirements }}</span>
        </div>
      </div>
      <!-- 职位描述 -->
      <div class="positionInfo">
        <p>职位描述 :</p>
        <p
          v-for="(item, index) in positionInfo"
          :key="index"
          style="word-wrap:break-word;word-break:break-all;overflow: hidden;"
        >
          {{ item }}
        </p>
      </div>

      <!-- 其他信息 -->
      <div class="positionRequirement">
        <p class="positionRequirementTitle">其他信息</p>
      </div>
      <!-- 发布人 -->
      <div class="workyears">
        <div>
          <span>发布人 :</span>
          <span>{{ publisher }}</span>
        </div>
      </div>
      <!-- 发布时间 -->
      <div class="workyears" style="margin-top:11px;">
        <div>
          <span>发布时间 :</span>
          <span>{{ createTime | formatDate }}</span>
        </div>
      </div>

      <!-- 评论 -->
      <div class="positionComment">
        <p class="positionCommentTitle">评论</p>
        <div
          class="commentBox"
          v-for="(item, index) in commentList"
          :key="index"
        >
          <span class="commentName">{{ item.name }}</span>
          <span class="commentTime">{{
            item.created_time | commentformatDate
          }}</span>
          <p class="commentText">{{ item.content }}</p>
        </div>
        <div class="loadMore" v-show="isMore">
          <el-button size="medium" class="loadmoreBtn" @click="handleGetMore"
            >加载更多</el-button
          >
        </div>
        <p v-show="isNo">暂无更多评论</p>
      </div>
    </div>
  </div>
</template>
<script>
import PositionApi from "@/api/PositionModule";
import { formatDate } from "@/assets/js/public";
export default {
  data() {
    return {
      isMore: true,
      isNo: false,
      companyLogo: "",
      // 被投递次数
      DeliveryNumber: "",
      // 被收藏次数
      CollectNumber: "",
      // 公司名称
      companyName: "",
      // 对外显示名称
      ExternalName: "",
      // 公司规模
      companySize: "",
      // 融资阶段
      FinancingStage: "",
      // 公司福利
      dynamicTags: [],
      // 公司简介
      companyInfo: "",
      // 职位名称
      positionName: "",
      // 职能分类
      FunctionalClassification: "",
      // 工作地点
      workplace: "",
      // 薪资范围
      SalaryRange: "",
      // 工作年限
      workyears: "",
      // 学历要求
      AcademicRequirements: "",
      // 发布人
      publisher: "",
      // 发布时间
      createTime: "",
      // 评论数据
      commentList: [],
      currentPage: 1,
      isHR: false,
      positionInfo: ""
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.$emit("defaultPath", val.meta.record[1].path);
      }
    }
  },
  created() {
    this.handleGetDetails();
    this.handleGetComment();
    // 通过cookie判断是hr还是猎头
    let member_type = JSON.parse(localStorage.getItem("account")).member_type;
    if (member_type === "hr") {
      this.isHR = true;
    } else {
      this.isHR = false;
    }
    // 控制是否展示对外显示名称
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
    commentformatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy.MM.dd hh:ss");
    }
  },
  methods: {
    // 跳转投递人数列表
    handleGoDeliveryNumber() {
      this.$router.push({
        path: "/deliveryNumber",
        query: { id: this.$route.query.id }
      });
    },
    // 获取职位详情
    handleGetDetails() {
      let detailId = this.$route.query.id;
      let params = `${detailId}?detail=1`;
      PositionApi.getPositionDetails(params)
        .then(res => {
          this.companyLogo = res.data.data.company_info.logo;
          this.DeliveryNumber = res.data.data.delivery_num;
          this.CollectNumber = res.data.data.collect_num;
          this.companyName = res.data.data.company_info.company_name;
          this.ExternalName = res.data.data.company_info.show_name;
          this.companySize = res.data.data.company_info.scale;
          this.FinancingStage = res.data.data.company_info.capitalization;
          this.dynamicTags = res.data.data.company_info.treatments;
          this.companyInfo = res.data.data.company_info.overview.split(/\n/g);
          this.positionInfo = res.data.data.intro.split(/\n/g);
          this.positionName = res.data.data.position_name;
          this.FunctionalClassification =
            res.data.data.position_field.field.field_name +
            "-" +
            res.data.data.position_field.position_name;
          this.workplace = res.data.data.city;
          this.SalaryRange = res.data.data.income;
          this.workyears = res.data.data.years;
          this.AcademicRequirements = res.data.data.educ;
          this.publisher = res.data.data.owner_name;
          this.createTime = res.data.data.publish_time;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取详情中的评论
    handleGetComment() {
      let detailId = this.$route.query.id;
      let params = `${detailId}/comment?limit=3&page=${this.currentPage}`;
      PositionApi.getPositionComment(params)
        .then(res => {
          if (res.data.data.length < 3 && res.data.data.length != 0) {
            // 第一页数据少于三条
            // 没有更多数据
            this.isMore = false;
            this.isNo = true;
            this.commentList = res.data.data;
          } else if (res.data.data.length === 3) {
            this.isMore = true;
            this.isNo = false;
            this.commentList = res.data.data;
          } else if (res.data.data.length === 0) {
            this.isMore = false;
            this.isNo = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 加载更多操作
    handleGetMore() {
      this.currentPage += 1;
      this.handleGetComment();
    }
  }
};
</script>
<style scoped>
.topbox {
  position: absolute;
  right: 0;
  top: -50px;
}
.showNum p:first-child {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
}
.detailsBox {
  background-color: #fff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
}
.detailsBox .companyMsg {
  padding-bottom: 15px;
  border-bottom: 1px solid #f5f6f9;
}
.detailsBox .companyMsg .companyMsgTitle {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #0077ff;
  padding-left: 10px;
}
.detailsBox .companyName {
  height: 40px;
  line-height: 40px;
  margin-top: 18px;
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  position: relative;
}
.detailsBox .companyName img {
  position: absolute;
  right: 30px;
}
.companySize {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.companySize div {
  width: 33%;
}
.companySize div span:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.companySize div span:last-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.companywelfare {
  margin-top: 20px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.companyInfo {
  margin-top: 20px;
}
.companyInfo p:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  margin-bottom: 7px;
}
.companyInfo p {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.positionMsg {
  margin-top: 43px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f5f6f9;
}
.detailsBox .positionMsg .positionTitle {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #0077ff;
  padding-left: 10px;
}
.detailsBox .positionName {
  margin-top: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.detailsBox .classification {
  margin-top: 13px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.detailsBox .classification div {
  width: 33%;
}
.detailsBox .classification div span:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.detailsBox .classification div span:last-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.detailsBox .positionRequirement {
  padding-bottom: 15px;
  border-bottom: 1px solid #f5f6f9;
  margin-top: 52px;
}
.detailsBox .positionRequirement .positionRequirementTitle {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #0077ff;
  padding-left: 10px;
}
.detailsBox .workyears {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.detailsBox .workyears div {
  width: 33%;
}
.detailsBox .workyears div span:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.detailsBox .workyears div span:last-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.detailsBox .positionInfo {
  margin-top: 17px;
}
.detailsBox .positionInfo p {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.detailsBox .positionInfo p:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  margin-bottom: 7px;
}
.detailsBox .positionComment {
  margin-top: 50px;
  padding-bottom: 50px;
}
.detailsBox .positionComment .positionCommentTitle {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.detailsBox .positionComment .commentBox {
  padding-left: 10px;
  border-left: 3px solid #eeeeee;
  margin-top: 22px;
  margin-bottom: 34px;
}
.detailsBox .positionComment .commentBox .commentName {
  font-size: 16px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  display: inline-block;
  margin-bottom: 11px;
}
.detailsBox .positionComment .commentBox .commentTime {
  display: inline-block;
  margin-bottom: 11px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(174, 186, 206, 1);
  margin-left: 13px;
}
.detailsBox .positionComment .commentBox .commentText {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.loadMore {
  width: 100%;
  height: 40px;
  position: relative;
}
.loadMore .loadmoreBtn {
  position: absolute;
  left: 50%;
  margin-left: -49px;
  top: 0;
}
</style>
<style>
.el-menu {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/position/positionDetails.vue